import { Factory } from 'rosie';

Factory.define('PhraseSuggestion').attr('name', 'PHRASE_SUGGESTION');

Factory.define('PhraseSuggestionWithDefaults')
  .extend('PhraseSuggestion')
  .attr('id', 'default-id')
  .attr('text', 'Hello, how are you?')
  .attr('score', 100);
